import {LoadingButton} from "./LoadingButton";

export {LoadingButton};

export default LoadingButton;
